export const blurOnWheel = (e) => e.target.blur();

export const PERCENT_INPUT_PROPS = { inputProps: { min: 0, max: 100 } };
